import * as yup from "yup";

// Reusable select option schema
const selectOptionSchema = yup.object({
  id: yup.string().required(),
  name: yup.string().optional(),
});

export const createRewardSchema = yup
  .object({
    title: yup.string().required("Ce champ est obligatoire"),

    type: yup
      .string()
      .oneOf(["BOOKING", "RIDE"], "Type doit être BOOKING ou RIDE")
      .required("Type is required"),

    promoScope: yup
      .string()
      .oneOf(["EVENT", "SPECIALS", "PLACE", "GLOBAL"])
      .when("type", {
        is: "BOOKING",
        then: (schema) => schema.required("Ce champ est obligatoire"),
        otherwise: (schema) => schema.nullable(),
      }),

    restrictionType: yup
      .string()
      .oneOf(["", "NONE", "EVENT", "SPECIALS", "PLACE"])
      .nullable()
      .optional(),

    event: selectOptionSchema.nullable(),
    offer: selectOptionSchema.nullable(),
    place: selectOptionSchema.nullable(),

    pointsRequired: yup
      .number()
      .typeError("Points requis doit être un nombre")
      .positive()
      .required(),

    discount: yup
      .number()
      .positive("La réduction doit être positive")
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire"),

    maxUses: yup
      .number()
      .positive("L'utilisation max doit être positive")
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire"),

    isActive: yup.boolean().default(true),
    isReusable: yup.boolean().default(false),
    description: yup.string().nullable(),
    expiresAt: yup
      .date()
      .nullable()
      .transform((value, originalValue) => {
        if (
          originalValue === "" ||
          originalValue === null ||
          originalValue === undefined
        ) {
          return null;
        }
        return value;
      })
      .typeError("Date invalide"),

    picture: yup.mixed().when("$mode", {
      is: "create",
      then: (schema) => schema.required("Ce champ est obligatoire"),
      otherwise: (schema) =>
        schema.test(
          "picture",
          "Ce champ est obligatoire",
          (value) =>
            value instanceof File ||
            (typeof value === "string" && value.length > 0),
        ),
    }),

    isFeatured: yup.boolean().default(false),

    items: yup.array().of(
      yup.object({
        serviceId: yup.string().required(),
        maxUses: yup.number().positive().required(),
      }),
    ),
  })
  .test("scope-validation", "Configuration invalide", function (values) {
    const { promoScope, event, offer, place } = values;

    if (promoScope === "GLOBAL") return true;

    if (promoScope === "EVENT" && !event)
      return this.createError({ path: "event", message: "Event requis" });
    if (promoScope === "SPECIALS" && !offer)
      return this.createError({ path: "offer", message: "Offer requis" });
    if (promoScope === "PLACE" && !place)
      return this.createError({ path: "place", message: "Place requis" });

    return true;
  });

export type createRewardDto = yup.InferType<typeof createRewardSchema>;
